import { useEffect, useState } from "react";

// Round avatar that falls back to initials when there is no photo or it fails to load.
const Avatar = ({
  name,
  src,
  size = 32,
}: {
  name?: string | null;
  src?: string | null;
  size?: number;
}) => {
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [src]);

  const url = src
    ? /^https?:\/\//.test(src)
      ? src
      : `https://api.honeconnect.com/storage/${src}`
    : "";
  const initials = (name ?? "?")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("");

  return url && !broken ? (
    <img
      src={url}
      alt=""
      onError={() => setBroken(true)}
      style={{ width: size, height: size }}
      className="rounded-full object-cover shrink-0"
    />
  ) : (
    <span
      style={{ width: size, height: size }}
      className="rounded-full bg-hc_F4EBFA text-honeConnectPurple text-xs font-semibold flex items-center justify-center shrink-0"
    >
      {initials || "?"}
    </span>
  );
};

export default Avatar;
